import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { SearchButton } from "../../UI/StandardButtons/StandardButtons";
import usePagedSortedTable, { TotalPageMappers, } from "../../Hooks/usePagedSortedTable";
import useCheckboxes from "../../Hooks/useCheckboxes";
import HighSchoolService from "../../../Services/HighSchool.service";
import { StateMultiSearch } from "../State/StateSearch";
const PAGE_SIZE = 15;
const SEARCH_DEFAULT = "";
// @ts-expect-error - TS7034 - Variable 'STATE_DEFAULT' implicitly has type 'any[]' in some locations where its type cannot be determined.
const STATE_DEFAULT = [];
const ZIP_CODE_DEFAULT = "";
const DEFAULT_SEARCH = {
    search: SEARCH_DEFAULT,
    // @ts-expect-error - TS7005 - Variable 'STATE_DEFAULT' implicitly has an 'any[]' type.
    state: STATE_DEFAULT,
    zipCode: ZIP_CODE_DEFAULT,
};
const HighSchoolLookup = ({ selected: selectedHighSchools, children, }) => {
    var _a;
    const [search, setSearch] = React.useState(SEARCH_DEFAULT);
    // @ts-expect-error - TS7005 - Variable 'STATE_DEFAULT' implicitly has an 'any[]' type.
    const [state, setState] = React.useState(STATE_DEFAULT);
    const [zipCode, setZipCode] = React.useState(ZIP_CODE_DEFAULT);
    const { getCheckbox, checkedItems } = useCheckboxes({
        externallyCheckedItems: selectedHighSchools || [],
        equalsFunc: (a, b) => a.id === b.id,
    });
    const [searchArgs, setSearchArgs] = React.useState(DEFAULT_SEARCH);
    const searchItems = () => {
        setSearchArgs({
            search,
            state,
            zipCode,
        });
    };
    const { table, dataState } = usePagedSortedTable({
        searchArgs,
        addCheckboxes: {
            useCheckboxesMakeCheckbox: getCheckbox,
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            getCheckedItem: (data, index) => data.data[index],
        },
        getNumPages: (result) => 
        // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'PagedResult<any>'.
        TotalPageMappers.EngagePagedResult(result, PAGE_SIZE),
        noDataComponent: "No High Schools found",
        initialSort: { sort: "name", order: "asc" },
        getData: (sort, page, sArgs) => {
            return HighSchoolService.search({
                query: sArgs.search,
                // @ts-expect-error - TS2339 - Property 'acronym' does not exist on type 'string'.
                state: sArgs.state.map((x) => x.acronym) || [],
                zipCode: sArgs.zipCode,
            }, {
                sort: sort === null || sort === void 0 ? void 0 : sort.sort,
                order: sort === null || sort === void 0 ? void 0 : sort.order,
                offset: page * PAGE_SIZE,
                max: PAGE_SIZE,
            });
        },
        columns: [
            {
                title: "Name",
                sortId: "highschoolname",
            },
            { title: "CEEB Code", sortId: "highschoolceebcode" },
            { title: "City", sortId: "highschoolcity" },
            { title: "State", sortId: "highschoolstate" },
            { title: "Zip Code", sortId: "highschoolzipcode" },
        ],
        // @ts-expect-error - TS2322 - Type '({ data }: { data: any; }) => any' is not assignable to type 'Node[][] & ((arg1: unknown) => Node[][])'.
        rows: ({ data }) => 
        // @ts-expect-error - TS7006 - Parameter 'highSchool' implicitly has an 'any' type.
        data.map((highSchool) => [
            highSchool.name,
            highSchool.ceebCode,
            highSchool.city,
            highSchool.state,
            highSchool.zipCode,
        ]),
    });
    return children({
        lookup: (_jsxs(_Fragment, { children: [_jsxs("div", { className: "mb-3 form-inline", children: [_jsxs("div", { className: "form-group mr-3 mt-2 ", children: [_jsx("label", { htmlFor: "highSchoolSearch", className: "sr-only", children: "Search" }), _jsx("input", { type: "text", className: "form-control", id: "highSchoolSearch", placeholder: "Search Name, CEEB, City", style: { width: 200 }, value: search, onChange: (event) => {
                                        setSearch(event.target.value);
                                    }, onKeyPress: (e) => {
                                        if (e.key === "Enter") {
                                            searchItems();
                                        }
                                    } })] }), _jsxs("div", { className: "form-group mr-3 mt-2 ", children: [_jsx("label", { htmlFor: "stateSearch", className: "sr-only", children: "State" }), _jsx(StateMultiSearch, { placeholder: "State(s)", style: { width: 300 }, value: state, onChange: (val) => {
                                        setState(val);
                                    }, "aria-label": "State(s)" })] }), _jsxs("div", { className: "form-group mr-3 mt-2 ", children: [_jsx("label", { htmlFor: "highSchoolSearch", className: "sr-only", children: "Zip Code" }), _jsx("input", { type: "number", className: "form-control", id: "highSchoolSearch", placeholder: "Zip Code", style: { width: 200 }, value: zipCode, onChange: (event) => {
                                        setZipCode(event.target.value);
                                    }, onKeyPress: (e) => {
                                        if (e.key === "Enter") {
                                            searchItems();
                                        }
                                    } })] }), _jsx("div", { className: "mt-2", children: _jsx(SearchButton, { isLoading: dataState.isLoading, onClick: () => {
                                    searchItems();
                                } }) })] }), _jsx("hr", {}), table] })),
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        totalNumItems: (_a = dataState.data) === null || _a === void 0 ? void 0 : _a.total,
        selectedItems: checkedItems,
        isLoading: dataState.isLoading,
    });
};
export default HighSchoolLookup;
